import { FlightText } from "../common/text"
import { IPageSelectionHistory } from "../containers/selectionSlice"
import _ from "lodash"

const { utcText, localText } = FlightText
export const utc = "utc"
export const localTime = "local"
export const timeOptions = [
  {
    value: utc,
    label: utcText,
    id: utc
  },
  {
    value: localTime,
    label: localText,
    id: localTime
  }
]

export const arrayIsEqual = (a: [], b: []) => {
  return a.length === b.length && a.every((val, index) => val === b[index])
}
export function compareDates(startDate: string, endDate: string) {
  const dateTime1 = startDate !== "" && new Date(startDate).getTime()
  const dateTime2 = endDate !== "" && new Date(endDate).getTime()
  const diff = dateTime2 - dateTime1

  if (diff > 0 || diff === 0) {
    return false
  } else {
    return true
  }
}

export const searchHistory = (
  pageHistory: IPageSelectionHistory,
  addToQuery: any
) => {
  let searchCriterias = []
  let lastSelection = null
  if (pageHistory) {
    const { history } = pageHistory
    const latestNewSearchIdx = _.findLastIndex(history, (h) => !h[addToQuery])
    searchCriterias = history.filter((h, idx) => idx >= latestNewSearchIdx)
    lastSelection = history[history.length - 1]
  }
  return { searchCriterias, lastSelection }
}
